module.exports = __webpack_public_path__ + "static/media/records.c5fb8d2c.svg";